import React from 'react'
import { Container, Row, Col, Button, Card, CardImg, CardBody } from 'reactstrap';
import lostImage from '../resources/404image.png'
import { Link } from 'react-router-dom';

class Lost404 extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Container className="p-3 justify-content-center">
          <Row>
            <Col>
              <Card style={{ maxWidth: 500 + 'px', margin:0 + " auto", float:'none' }} className="text-center">
                <CardImg src={lostImage} />
                <CardBody>
                  <Link to="/">
                    <Button color="dark" style={{ position: 'absolute', top: 0, right: 0 }} className="float-righ m-3" >Inicio</Button>
                  </Link>
                  <h4>Ihhh... Acho que você se perdeu</h4>
                  <p>Clica em <strong>Inicio</strong> e volta pra gente</p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}

export default (Lost404)